<template lang="pug">
  
  div
    MHeader( page-title="Superuser Tools" )

    div( class="row mt-4" )
      div( class="col-12" )
        div( class="ibox" )
          div( class="ibox-content" )
            button( class="btn btn-primary" v-on:click="downloadLoggingCsv" v-bind:disabled="loading" ) Download Login Logs CSV
    
    div( class="row mt-4" )
      div( class="col-12" )
        div( class="ibox" )
          div( class="ibox-content" )
            h2 Queue Purging
            apollo-query( v-bind:query="gql => gql`query { queues }`" v-bind:tag="null" )
              template( v-slot="{ result: { loading: apolloLoading, error, data } }" )
                span( v-if="apolloLoading" ) Loading...
                div( v-else-if="data" )

                  p
                    select( class="form-control" v-model="queueToPurge" )
                      option( v-bind:value="null" ) Please select a queue to purge
                      option( v-for="q in data.queues" v-bind:value="q" ) {{ q.split('/').pop().split('.fifo')[0] }}
                  
                  p( class="text-right" )
                    label
                      strong I understand this will purge all messages in the specified queue which will potentially leave batches in an unfinished state.
                      input( type="checkbox" v-model="confirmPurge" )
                    br
                    button( class="btn btn-danger" v-bind:disabled="! confirmPurge || purging || queueToPurge === null" v-on:click="purgeQueue" )
                      MLoadingSpinner( v-if="purging" class="mr-2" )
                      | Purge Queue

    div( class="row mt-4" )
      div( class="col-12" )
        div( class="ibox" )
          div( class="ibox-content" )
            h2 Link Assurance Testing

            p
              label Link to check:
              input( class="form-control" v-model="assuranceLinkToCheck" )

            p( class="text-right" )
              button( class="btn btn-primary" v-bind:disabled="loadingAssurance" v-on:click="loadAssurance" )
                MLoadingSpinner( class="mr-2" v-if="loadingAssurance" )
                | Load Assurance
            

            div( v-if="assurance" )
              hr
              h3 Assurance Info&nbsp;
                a( href="#" v-on:click.prevent="showAssuranceInfo = ! showAssuranceInfo" )
                  span( v-if="showAssuranceInfo" ) Hide
                  span( v-else ) Show
              
              div( class="ibox" v-if="showAssuranceInfo" )
                div( class="ibox-content" )
                  p
                    router-link( v-bind:to="`/reporting/audits/${assurance.auditId}/output-report`" target="_blank" )
                      i( class="fa fa-external-link mr-2" )
                      | Go to audit
                  p
                    strong Requested By (Company):&nbsp;
                    | {{ assurance.assuranceRequestedBy }}
                  p
                    strong Assurance Expires On:&nbsp;
                    | {{ dateFormat(assurance.assuranceExpiresOn, 'yyyy-mm-dd HH:MM') }}

              h3( class="mt-4" ) Client Button Preview
              div( v-bind:data-moonpull-assurance-link="assuranceLinkToCheck" )

              h3( class="mt-4" ) Client IFrame Preview
              iframe( class="w-100" v-bind:src="assuranceIframeSrc" )

              p( class="text-right" )
                button( class="btn btn-danger" v-on:click="deleteAssurance" v-bind:disabled="deletingAssurance" )
                  MLoadingSpinner( v-if="deletingAssurance" class="mr-2" )
                  | Purge this assurance
    
    div( class="row mt-4" )
      div( class="col-12" )
        div( class="ibox" )
          div( class="ibox-content" )
            h2 RanMID Tool
            MRanMidTool

    div( class="row mt-4" )
      div( class="col-12" )
        div( class="ibox" )
          div( class="ibox-content" )

            div( v-if="$apollo.queries.isApiDisabled.loading" ) Loading...

            div( v-else-if="isApiDisabled" )
              h2 Enable Link Submission

              p Re-enable clients' ability to submit links

              p( class="text-right" )
                button( class="btn btn-success" v-on:click="setApiDisabled(false)" v-bind:disabled="loadingApiStatus" ) Re-enable API

            div( v-else )
              h2 Disable Non-SU Link Submission

              p.
                This will disable all non-superuser's ability to submit links. This is useful if you need to
                prevent clients from submitting data due to a known and ongoing platform issue, for example.
              
              p
                textarea( class="form-control" placeholder="PSA" v-model="disabledPsa" rows="3" )
              
              p( class="text-right" )
                label
                  strong I understand this will prevent ALL non-SU from submitting links&nbsp;
                  input( type="checkbox" v-model="confirmDisable" )
                br
                button(
                  class="btn btn-danger"
                  v-on:click="setApiDisabled(true)"
                  v-bind:disabled="loadingApiStatus || ! confirmDisable || ! disabledPsa.length"
                ) Disable API

</template>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
import * as dateFormat from 'dateformat'

const { VUE_APP_MOONPULL_API_ENDPOINT } = process.env

function moonpullInit() {
  let success = false
  const moonpullInitInterval = setInterval(() => {
    if (! success) {
      try {
        window.MoonpullAssurance.init()
        success = true
      } catch (e) {}
    }
    else {
      clearInterval(moonpullInitInterval)
    }
  }, 500)
}

export default Vue.extend({

  data() {
    return {
      loading: false,
      confirmPurge: false,
      queueToPurge: null,
      purging: false,
      loadingAssurance: false,
      assurance: null,
      showAssuranceInfo: false,
      assuranceLinkToCheck: '',
      assuranceIframeSrc: '',
      deletingAssurance: false,
      loadingApiStatus: false,
      confirmDisable: false,
      disabledPsa: '',
    }
  },

  apollo: {
    isApiDisabled: {
      query: gql`
        query IsApiDisabled {
          platformContentByKey(key: "isApiDisabled")
        }
      `,
      update: data => JSON.parse(data.platformContentByKey),
    }
  },

  methods: {
    dateFormat,

    async downloadLoggingCsv() {
      this.loading = true
      const res = this.$moonpull.downloadCsv(await this.$moonpull.getLogging(), 'logging.csv')
      this.loading = false
    },

    async purgeQueue() {
      this.purging = true
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation PurgeQueue($queueUrl: String!) {
            purgeQueue(
              queueUrl: $queueUrl
            )
          }`,
          variables: {
            queueUrl: this.queueToPurge,
          }
        })
        this.$store.dispatch('flashMessage', { type: 'success', msg: `Successfully purged queue "${this.queueToPurge}"` })
        this.confirmPurge = false
        this.queueToPurge = null
      } catch (e) {
        this.$store.dispatch('flashMessage', { type: 'danger', msg: `Error purging queue "${this.queueToPurge}": ${e.message}` })
      }
      this.purging = false
    },

    async loadAssurance() {
      this.loadingAssurance = true
      this.assurance = await this.$moonpull.getAssurance(this.assuranceLinkToCheck)
      if (! this.assurance) {
        alert('No assurance found for this link')
      }
      else {
        this.assuranceIframeSrc = `${VUE_APP_MOONPULL_API_ENDPOINT}/client/v1/assurance/${this.assurance.assuranceId}`

        // Load script if it doesn't exist
        const moonpullScriptId = 'moonpull-assurance-script'
        const moonpullScript = document.getElementById(moonpullScriptId)
        if (! moonpullScript) {
          const script = document.createElement('script')
          script.setAttribute('id', moonpullScriptId)
          script.src = `${VUE_APP_MOONPULL_API_ENDPOINT}/client/v1/assurance/embed.js`
          document.body.appendChild(script)
        }
        moonpullInit()
      }
      this.loadingAssurance = false
    },

    async deleteAssurance() {
      this.deletingAssurance = true
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!) {
          assuranceDeleteById(id: $id)
        }`,
        variables: {
          id: this.assurance.assuranceId,
        }
      })
      this.deletingAssurance = false
      this.assuranceLinkToCheck = ''
      this.assurance = null
      this.$store.dispatch('flashMessage', { type: 'success', msg: `Successfully purged assurance` })
    },

    async setApiDisabled(disabled) {
      this.loadingApiStatus = true
      await this.$apollo.mutate({
        mutation: gql`
          mutation ToggleApiDisabled($isDisabled: String!) {
            updatePlatformContentByKey(key: "isApiDisabled", value: $isDisabled)
          }
        `,
        variables: {
          isDisabled: (disabled) ? 'true' : 'false',
        }
      })
      await this.$apollo.mutate({
        mutation: gql`
          mutation UpdatePSA($psa: String!) {
            updatePlatformContentByKey(key: "psa", value: $psa)
          }
        `,
        variables: {
          psa: (disabled) ? this.disabledPsa : '',
        }
      })
      await this.$apollo.queries.isApiDisabled.refetch()
      this.confirmDisable = false
      this.disabledPsa = ''
      this.loadingApiStatus = false
      this.$store.dispatch('flashMessage', { type: 'success', msg: `Successfully ${disabled ? 'disabled' : 'enabled'} API` })
    },
    
  },

  beforeCreate() {
    if (! this.$moonpull.currentUserIsSuperAdmin()) {
      this.$router.push({ name: 'reporting-batches' })
    }
  },

})
</script>
